import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(`
  query UserVotedNarratives {
    UserVotedNarratives {
      narrativeId
    }
  }
`);

export const useUserVotedNarratives = makeGqlQuery(QUERY, {
  tags: ['narrative'],
});
